(() => {
  'use strict';

  const config = window.BasicShopifyConfig;
  const accountUrl = config?.routes?.account || '/account';
  const language = (config?.locale || document.documentElement.lang || 'fr').slice(0, 2);
  const labels = {
    fr: { account: 'Mon compte', open: 'Ouvrir mon compte' },
    de: { account: 'Mein Konto', open: 'Mein Konto öffnen' },
    en: { account: 'My account', open: 'Open my account' }
  };
  const label = labels[language] || labels.fr;
  const headerActions = document.querySelector('.header-actions');
  const mobileNav = document.querySelector('.mobile-primary-nav');

  if (headerActions && !headerActions.querySelector('.account-space-trigger')) {
    const desktopLink = document.createElement('a');
    desktopLink.className = 'icon-button account-space-trigger';
    desktopLink.href = accountUrl;
    desktopLink.setAttribute('aria-label', label.open);
    desktopLink.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="7.6" r="3.5"/><path d="M4.8 20c.5-4.1 3.1-6.2 7.2-6.2s6.7 2.1 7.2 6.2"/></svg>';
    headerActions.insertBefore(desktopLink, headerActions.querySelector('.search-toggle'));
  }

  if (mobileNav && !mobileNav.querySelector('.account-space-mobile-trigger')) {
    const mobileLink = document.createElement('a');
    mobileLink.className = 'mobile-nav-direct account-space-mobile-trigger';
    mobileLink.href = accountUrl;
    const text = document.createElement('span');
    text.textContent = label.account;
    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    mobileLink.append(text, arrow);
    mobileNav.append(mobileLink);
  }
})();
